<template>
    <v-card flat>
        <v-overlay :value="loadingTagData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{ activeTag.name ? activeTag.name : activeTag.id }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                dark
                color="bal-red"
                @click="editTag"
                v-if="hasPermissionForAction(PermissionsConstants.TAG, PermissionsConstants.EDIT)"
            >
                <v-icon>edit</v-icon>
                {{ "Edit" | t }}
            </v-btn>
            <v-menu
                offset-y
                bottom
                left
                v-if="hasPermissionForAction(PermissionsConstants.TAG, PermissionsConstants.DELETE)"
            >
                <template v-slot:activator="{ on }">
                    <v-btn color="bal-dark-gray" class="px-2 ml-2 mx-2" style="min-width: 0;" dark v-on="on">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="handleDeleteClick">
                        <v-list-item-title style="color: red">{{ "Delete" | t }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "General" | t }}
            </v-tab>
            <v-tab style="text-transform: none !important;">
                {{ "Clients" | t }}
                <span v-if="activeTag.clients" class="ml-1" style="color: gray;">({{ activeTag.clients.length }})</span>
            </v-tab>
            <v-tab-item>
                <general-tab />
            </v-tab-item>
            <v-tab-item>
                <clients-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import GeneralTab from "./tag-tab-items/general-tab";
import ClientsTab from "./tag-tab-items/clients-tab";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "tag-view",
    components: { GeneralTab, ClientsTab },
    data() {
        return {
            tab: 0,
            tabs: ["General", "Clients"]
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.nextTab);
        await this.getTagData(this.$route.params.tagId);
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    computed: {
        ...mapState("TagStore", ["activeTag", "loadingTagData"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.nextTab);
    },
    methods: {
        ...mapActions("TagStore", ["getTagData", "deleteTag"]),
        closeDrawer() {
            this.$router.push({ name: "tag-list" });
        },
        editTag() {
            this.$router.push({
                name: "tag-edit",
                params: { tagId: this.$route.params.tagId, tab: this.tabs[this.tab] }
            });
        },
        nextTab(e) {
            if (e.keyCode === 69 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.editTag();
            }
            if (e.key === "ArrowLeft") {
                if (this.tab > 0) {
                    this.tab -= 1;
                }
            } else if (e.key === "ArrowRight") {
                if (this.tab + 1 < this.tabs.length) {
                    this.tab += 1;
                }
            }
        },
        async handleDeleteClick() {
            if (confirm("Are you sure you want to delete this tag?")) {
                await this.deleteTag({
                    tagId: this.activeTag.id
                });
            }
        }
    }
};
</script>

<style scoped></style>
